import React from "react";
import MarketItem from "../../components/MarketItem";
import {
  group,
  marketBg,
  marketPlaceMobile,
  marketUpperCard,
} from "../../images/general";
import CustomButtton from "../../components/Button/CustomButtton";
import { Link } from "gatsby";
import { constants } from "../../utils/constants";
import { useSkuState } from "../../context/SkuContext";
import { SkuType } from "../../types/Sku";

const HomeMarketplace = () => {
  const {
    state: {sku : skuList}
} = useSkuState();

  return (
    <>
      <section
        className="sm:block hidden w-full bg-no-repeat bg-cover bg-center h-full"
        style={{ backgroundImage: `url(${marketBg})` }}
      >
        <div className="container max-w-7xl px-4 py-16 mx-auto">
          <div
            className="sm:lg:flex hidden"
            data-sal="fade-in"
            data-sal-delay="400"
            data-sal-easing="ease"
          >
            <div className="lg:w-1/2 mb-32">
              <h3 className="sm:text-7xl text-[20px] font-cinzel text-white font-bold sm:leading-[64px] sm:mx-0 mx-auto sm:text-left text-center leading-7 max-w-md w-full uppercase">
                Marketplace
              </h3>
            </div>

            <div className="lg:w-1/2 mt-6 lg:mt-0 relative">
              <img
                src={marketUpperCard}
                className="absolute -top-32 right-0 "
              />
            </div>
          </div>
          <div
            className="hidden sm:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:px-0 px-4 items-center pt-12 pb-7 relative z-10"
            data-sal="slide-up"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            {skuList
              .filter((x) => x.type === SkuType.SILVER_PACKAGE)
              .map((item, i) => (
                <MarketItem item={item} key={i} isHome={true} />
              ))}
          </div>
        </div>
      </section>
      {/* Mobile */}
      <section
        className="sm:hidden block w-full bg-no-repeat bg-cover bg-center h-max py-1 -mt-5"
        style={{ backgroundImage: `url(${marketPlaceMobile})` }}
      >
        <div className="container max-w-7xl px-4 pt-[17rem] pb-4 mx-auto"         
        data-sal="fade-in"
        data-sal-delay="400"
        data-sal-easing="ease">
          <div className="">
            <div className="lg:w-1/2 ">
              <h3 className="sm:text-7xl text-[28px] font-cinzel text-white font-bold sm:leading-[64px] sm:mx-0 mx-auto sm:text-left text-center leading-7 max-w-md w-full uppercase pb-9">
                Marketplace
              </h3>
              <div className="w-[70%] mx-auto mb-3 md:mb-0 ">
                <Link to={constants.app_routes.marketplace.home}>
                  <CustomButtton text="Visit" icon2={group}/>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeMarketplace;
